import React from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router';
import { Transition } from 'react-transition-group';
import core, { App } from '@gin-betting/core';
import { BannerTypes } from '@gin-betting/banners';
import { TimePeriod } from '@gin-betting/constants';

import type { WidgetType } from '../../types';
import { WIDGETS } from '../../constants';
import { getAttributesByPeriod } from '../../utils';
import TopMatch from './TopMatch';
import { isMobile } from 'app-constants';
import ColorfulBanners from '../ColorfulBanners';
import './topMatchList.scss';

interface Props {
    sportType: App.SportType;
}

const topMatchListIndexConfig: { [key in WidgetType]: number } = {
    weekly: TimePeriod.Weekly,
    monthly: TimePeriod.Monthly,
};

const attributesByType = getAttributesByPeriod(topMatchListIndexConfig);

const {
    constants: { SportType },
} = core;

const TopMatchList: React.FC<Props> = ({ sportType }) => {
    const { search } = useLocation();

    const isVisible = search === '';

    const isMixPage = sportType === SportType.Mix;

    return (
        <Transition in={isVisible} timeout={300}>
            {transition => {
                if (transition === 'exited') {
                    return null;
                }

                return (
                    <div
                        styleName={cn('container', {
                            'is-visible': transition === 'entered',
                        })}
                    >
                        {isMixPage && (
                            <ColorfulBanners
                                zoneLocation={
                                    BannerTypes.BannerZoneLocation.TOP_SLIDER
                                }
                            />
                        )}

                        <div styleName="widget-wrapper">
                            {!isMobile &&
                                WIDGETS.map(type => {
                                    const zoneAttributes =
                                        attributesByType[type];

                                    if (!zoneAttributes) return null;

                                    return (
                                        <TopMatch
                                            key={type}
                                            type={type}
                                            zoneAttributes={zoneAttributes}
                                        />
                                    );
                                })}
                        </div>
                    </div>
                );
            }}
        </Transition>
    );
};

export default TopMatchList;
